import {
  FirebaseApp,
  initializeApp as initializeFirebaseApp
} from 'firebase/app'
import 'firebase/analytics'
import { Analytics, getAnalytics } from 'firebase/analytics'
import { getMessaging, Messaging, onMessage } from 'firebase/messaging'

export let app: FirebaseApp
export let analytics: Analytics
export let messaging: Messaging

export async function initializeApp() {
  app = initializeFirebaseApp({
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: 'findoo-production.firebaseapp.com',
    databaseURL: 'https://findoo-production.firebaseio.com',
    projectId: 'findoo-production',
    storageBucket: 'findoo-production.appspot.com',
    messagingSenderId: '761464488580',
    appId: '1:761464488580:web:e50e4c860a27a60f5db8d1',
    measurementId: 'G-162123810'
  })

  analytics = getAnalytics(app)
  messaging = getMessaging(app)

  onMessage(messaging, console.debug)
}
